<template>
    <div id="page_Container" :class="{'no-activity': !activityImgDetail.status}">
        <div class="page" id="activity-page" v-if="activityImgDetail.status">
            <div id="main-container" class="main-container" >

                <div v-for="(curMapItem) in curMap" :key="curMapItem.id" class="map-div">
                    <img
                        :src="curMapItem.img[0].photoUrl"
                        class="imgContent"
                        draggable="false"
                        :usemap="`#Map${curMapItem.id}`"
                    />
                    <map :name="`#Map${curMapItem.id}`">
                        <area v-for="(item, i) in curMapItem.area" :key="i" :shape="item.rect" :coords="item.coords" @click="openOtherPage(item.href)"   />
                    </map>
                </div>
            </div>
        </div>

        <div v-else class="no-activity">
            <img  src="../assets/img/myCenter/noActivity.png" alt="">
            <div>活动已结束</div>
        </div>

    </div>
</template>

<script>
import {
    toastLoading,
    clearToastLoading
} from '@/utils/base/utils';
import {
    wxCircle,
    wxFriends
} from '@/base/share.js';
import { mapGetters } from 'vuex';
export default {
    data() {
        return {
            activityImgDetail: {},
            mapDate: [],
            curMap: {},
            imgRatio: 1
        };
    },
    esvShow() {
        // this.init();
        this.ESVStorage.getSessionValue('onceActive', (data) => {
            console.log(data);
            if (data === '1') {
                this.ESVStorage.putSessionValue('onceActive', '0', () => {
                    location.reload();
                });
            } else {
                this.init();
            }
        });
    },
    methods: {
        login() {
            this.esvOpenPage('OPLogin');
        },
        openOtherPage(url) {
            this.esvOpenUrl(url);
        },

        init() {
            const shareUrl = this.getBaseUrl() + '#/OPActivityPage' + '?activityImgId=' + this.$route.query.activityImgId;
            Promise.all([this.getActivityImgDetail({ id: this.$route.query.activityImgId }), this.getShortOauthUrl(shareUrl, this.merchantInfo.merchantCode)]).then((data) => {
                this.onMenuFriend(this.link);
            });
        },
        getBaseUrl() {
            return window.location.href.split('#')[0];
        },
        getActivityImgDetail(params) {
            return new Promise((resolve, reject) => {
                this.$doRequest({
                    url: '/activityImg/getActivityImgDetail',
                    params: params,
                    before: function () {
                        this.loading = toastLoading();
                    },
                    complete: function () {
                        clearToastLoading(this.loading);
                    }
                }, (data) => {
                    document.title = data.result.name;
                    this.activityImgDetail = data.result;
                    //   // 获取上传数据比例
                    this.mapDate = JSON.parse(data.result.imgsJson);
                    this.curMap = this.ESVBase.deepCopy(this.mapDate);
                    this.mapDate.forEach((item, i) => {
                        this.setImgMap(item.width, i);
                    });
                    console.log(this.mapDate, 'mapDate');
                    resolve();
                });
            });
        },
        onMenuFriend(link) {
            const shareImg = this.mapDate[0].img[0].photoUrl;
            console.log('点击分享');
            wxCircle(this.activityImgDetail.name, this.link, shareImg, 'activity');
            wxFriends(this.activityImgDetail.name, '', this.link, shareImg);
        },
        // 将要分享的链接转为短链接
        getShortOauthUrl(url, merchantCode) {
            console.log(url, 'shortUrl');

            return new Promise((resolve, reject) => {
                this.$doRequest({
                    url: '/oauth/getShortOauthUrl',
                    params: {
                        url,
                        merchantCode
                    },
                    before: function () {
                        this.loading = toastLoading();
                    },
                    complete: function () {
                        clearToastLoading(this.loading);
                    }
                },
                (data) => {
                    this.link = data.result;
                    console.log(this.link);
                    resolve();
                }
                );
            });
        },
        setImgMap(naturalWidth, i) {
            // let img = document.querySelector('img');
            const width = window.innerWidth ||
                document.documentElement.clientWidth ||
                document.body.clientWidth;
            this.imgRatio = width / naturalWidth;
            this.curMap[i].area.forEach(ele => {
                ele.coords = ele.coords
                    .split(',')
                    .map(item => {
                        return (item * this.imgRatio).toFixed(2);
                    })
                    .join(',');
            });
        }

    },
    computed: {
        ...mapGetters(['merchantInfo'])
    }
};
</script>

<style lang="scss">
    #activity-page {
        img {
            width: 100%;
            display: block;
        }
        area {
            outline: none;
        }
    }
    .no-activity {
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction:column;
        img {
            width: 80%;
            display: block;
            margin-bottom: 20px;
        }
        color: #999;
        text-align: center;
    }
</style>
